import {
  getWebsiteIntent,
  getCompanyList,
  getCompanySession,
} from "@/api/website-intent";
import { getCompanyGroupList, getPeopleGroupList } from "@/api/contact";

export const getInitialFilterState = () => ({
  start_date: null,
  end_date: null,
  company_name: null,
  locations: new Map(),
  verticals: [],
  vertical_categories: [],
  technologies: [],
  categories: [],
  vertical_sub_categories: [],
  advertisements: [],
  pageview_greater_than: null,
  session_greater_than: null,
  company_groups: [],
  news_categories: [],
  news_published_dates: [],
  job_locations: new Map(),
  job_exclude_locations: new Map(),
  job_posted_dates: [],
  job_titles: [],
  keywords: [],
  advertisement_target_locations: new Map(),
  advertisement_exclude_target_locations: new Map(),
  advertisement_search_terms: [],
  advertisement_start_dates: [],
  advertisement_end_dates: [],
  time: [],
  search_term: "",
  page: 1,
  per_page: 100,
});

const state = {
  selected: getInitialFilterState(),
  pageInfo: {
    page: 1,
    pageSize: 100,
  },

  smallSize: false,
  intentSelectedModule: "",
  domainId: null,
  domainSearchId: null,
  trackingDomainId: null,
  leadId: null,
  websiteList: [],
  companyList: [],
  companyInfo: {},
  passInfo: {},

  companyGroupList: [],
  peopleGroupList: [],
  filterShow: false,
  sequenceList: {},
};

const getters = {
  apiPayload: (state, getters, rootState) => {
    const { selected } = state;

    const payload = {
      ...selected,
      profile_id: rootState.user.currentId.profile_id,
      technologies: selected.technologies.map((item) => item.value),
      categories: selected.categories.map((item) => item.value),
      advertisements: selected.advertisements.map((item) => item.value),
      company_groups: selected.company_groups?.map((item) => item.value),
      verticals: selected.verticals.map((item) => item.value),
      vertical_categories: selected.vertical_categories.map(
        (item) => item.value,
      ),
      locations: !selected.locations.size ? [] : [...selected.locations.keys()],
      vertical_sub_categories: selected.vertical_sub_categories.map(
        (item) => item.value,
      ),
      news_categories: selected.news_categories.map((item) => item.value),
      job_locations: [...selected.job_locations.keys()],
      job_exclude_locations: [...selected.job_exclude_locations.keys()],
      advertisement_target_locations: [
        ...selected.advertisement_target_locations.keys(),
      ],
      advertisement_exclude_target_locations: [
        ...selected.advertisement_exclude_target_locations.keys(),
      ],
      start_date: selected.time.length ? selected.time[0] : null,
      end_date: selected.time.length ? selected.time[1] : null,
    };
    return payload;
  },
};

const mutations = {
  SET_FILTERS_FROM_PAYLOAD(state, payload) {
    state.selected = {
      ...getInitialFilterState(),
      ...state.filter,
      ...payload,
    };
  },

  UPDATE_FILTER(state, { dataKey, value }) {
    if (Object.prototype.hasOwnProperty.call(state.selected, dataKey)) {
      state.selected = { ...state.selected, [dataKey]: value };
    }
  },

  UPSERT_TO_MAP_FILTER(state, { dataKey, item }) {
    if (state.selected[dataKey] instanceof Map) {
      state.selected[dataKey].set(item.value, item);
      state.selected = { ...state.selected };
    }
  },

  ADD_TO_ARRAY_FILTER(state, { dataKey, item }) {
    if (Array.isArray(state.selected[dataKey])) {
      const list = state.selected[dataKey];
      const exists = list.some((i) => i.value === item.value);
      if (!exists) {
        list.push(item);
        state.selected = { ...state.selected };
      }
    }
  },

  REMOVE_FROM_MAP_FILTER(state, { dataKey, itemValue }) {
    if (state.selected[dataKey] instanceof Map) {
      if (state.selected[dataKey].delete(itemValue)) {
        state.selected = { ...state.selected };
      }
    }
  },

  REMOVE_FROM_ARRAY_FILTER(state, { dataKey, itemValue }) {
    if (Array.isArray(state.selected[dataKey])) {
      const list = state.selected[dataKey];
      const index = list.findIndex((i) => i.value === itemValue);
      if (index > -1) {
        list.splice(index, 1);
        state.selected = { ...state.selected };
      }
    }
  },

  CLEAR_COMPOSITE_FILTER(state, dataKey) {
    if (dataKey === "industry") {
      state.selected.vertical_sub_categories = [];
      state.selected.vertical_categories = [];
    } else if (dataKey === "technology") {
      state.selected.technologies = [];
      state.selected.categories = [];
    } else if (dataKey === "news") {
      state.selected.news_categories = [];
      state.selected.news_published_dates = [];
    } else if (dataKey === "jobs") {
      state.selected.job_locations = new Map();
      state.selected.job_exclude_locations = new Map();
      state.selected.job_posted_dates = [];
      state.selected.job_titles = [];
    } else if (dataKey === "advertisement") {
      state.selected.advertisement_target_locations = new Map();
      state.selected.advertisement_exclude_target_locations = new Map();
      state.selected.advertisement_search_terms = [];
      state.selected.advertisement_start_dates = [];
      state.selected.advertisement_end_dates = [];
    }
    state.selected = { ...state.selected };
  },

  RESET_ALL_FILTERS(state) {
    state.selected = getInitialFilterState();
  },

  setSmallSize(state, payload) {
    state.smallSize = payload;
  },
  setIntentSelectedModule(state, payload) {
    state.intentSelectedModule = payload;
  },
  setDomainId(state, domainId) {
    state.domainId = domainId;
  },
  setDomainSearchId(state, domainSearchId) {
    state.domainSearchId = domainSearchId;
  },
  setTrackingDomainId(state, trackingDomainId) {
    state.trackingDomainId = trackingDomainId;
  },
  setLeadId(state, leadId) {
    state.leadId = leadId;
  },
  setWebsiteList(state, payload) {
    state.websiteList = payload;
  },
  setCompanyList(state, payload) {
    state.companyList = payload;
  },
  setCompanyInfo(state, payload) {
    state.companyInfo = payload;
  },
  setPassInfo(state, payload) {
    state.passInfo = payload;
  },
  setPageInfo(state, payload) {
    state.pageInfo = payload;
  },
  setCompanyGroupList(state, payload) {
    state.companyGroupList = payload;
  },
  setPeopleGroupList(state, payload) {
    state.peopleGroupList = payload;
  },
  // intent filter 的展示/隐藏
  setFilterShow(state, payload) {
    state.filterShow = payload;
  },
  setSequenceList(state, payload) {
    state.sequenceList = payload;
  },
};

const actions = {
  updateFilter({ commit }, payload) {
    // payload: { dataKey, value }
    commit("UPDATE_FILTER", payload);
  },

  clearFilterGroup({ commit }, dataKey) {
    if (
      ["industry", "technology", "news", "jobs", "advertisement"].includes(
        dataKey,
      )
    ) {
      commit("CLEAR_COMPOSITE_FILTER", dataKey);
    } else {
      const initialValue = getInitialFilterState()[dataKey];
      commit("UPDATE_FILTER", { dataKey, value: initialValue });
    }
  },

  clearAllFilters({ commit }) {
    commit("RESET_ALL_FILTERS");
  },

  async changeWebsiteList({ commit, _, rootState }) {
    const { data } = await getWebsiteIntent({
      profile_id: rootState.user.currentId.profile_id,
    });
    const nowTime = new Date().getTime();
    commit(
      "setWebsiteList",
      data.map((item) => ({
        ...item,
        leftDays:
          (new Date(item.expired_at).getTime() - nowTime) / 1000 / 60 / 60 / 24,
      })),
    );
    return data;
  },
  async changeCompanyList({ commit }, params) {
    const { data } = await getCompanyList(params.params);
    if (params.reset) {
      commit("setCompanyList", data.leads ? data.leads : []);
    } else {
      commit("setCompanyList", [...state.companyList, ...data.leads]);
    }
    return {
      list: params.reset
        ? data.leads
          ? data.leads
          : []
        : [...state.companyList, ...data.leads],
      pagination: data.pagination,
    };
  },
  async getCompanySession(context, data) {
    const res = await getCompanySession(data);
    context.commit("setCompanyInfo", res.data);
    return res.data;
  },
  async getList({ commit, state, rootState }, data) {
    const profileId = rootState.user.currentId.profile_id;
    const { type } = data;
    let result = null;
    // commit('setType', type);
    // commit('setPersonal', isPersonal);
    const params = {
      profile_id: profileId,
    };
    if (type === "PEOPLE") {
      result = await getPeopleGroupList(params);
      commit("setPeopleGroupList", result.data);
    } else if (type === "COMPANY") {
      result = await getCompanyGroupList(params);
      commit("setCompanyGroupList", result.data);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
